import React, { ButtonHTMLAttributes, ForwardedRef, PropsWithChildren } from "react";
import { GatsbyLinkProps } from "gatsby";
import Link from "gatsby-link";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { Props } from "../lib/interfaces";
import { spring } from "../styles/motion";

const buttonText = css`
  margin-left: 10px;
`;


interface ButtonProps {
  icon: any;
}

const Component = React.forwardRef((props: Partial<GatsbyLinkProps<any>> & ButtonProps & ButtonHTMLAttributes<any>, ref: ForwardedRef<any>) => {
  const inner = props.children && <span css={ buttonText }>{ props.children }</span>;
  return !props.to ?
    <button ref={ ref } className={ props.className } onClick={ props.onClick }>{ inner }</button> :
    // @ts-ignore
    <Link ref={ ref } { ...props }>
      { inner }
    </Link>;
});

const MotionButton = motion(Component);

function Button(props: Props<PropsWithChildren<any>>) {
  return <MotionButton whileHover={ { scale: 1.1 } }
                       whileTap={ { scale: 0.92 } }
                       transition={ spring }
                       { ...props }/>;
}

export const ButtonWithIcon = styled(Button)<any>`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;

  ::before {
    content: "";
    display: block;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: ${ (props: any) => props.bgColor ?? "rgb(169 168 183 / 10%)" } url(${ props => props.icon }) no-repeat center;
    background-size: 14px 14px;
  }
`;